import BasePage from "../../../base/BasePage";
import React from "react";
import RegionTab from "../../../components/common/RegionTab";
import LeaveRequestPage from "./LeaveManagementTable/LeaveRequestPage";
import ModernizationRequestPage from "./LeaveManagementTable/ModernizationRequestPage";
import withRouter from "../../../withRouter";

class LeaveManagementPage extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      progress: false,
    };
  }

  render() {
    const tabs = [
      { title: "Leave Requests", content: <LeaveRequestPage /> },
      // {
      //   title: "Monetization Requests",
      //   content: <ModernizationRequestPage />,
      // },
    ];
    const tabContents = tabs.map((tab) => tab.content);
    return (
      <>
        <div
          className={`container-fluid d-flex flex-column ${
            this.isMobile() ? "pt-5" : "p-5"
          }`}
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Employee Self Service &gt;{" "}
              <span style={{ color: "#333" }}>Leave Management</span>
            </p>
          </div>
          <RegionTab tabs={tabs} tabContents={tabContents} />
        </div>
      </>
    );
  }
}

export default withRouter(LeaveManagementPage);
